/*eslint-disable no-underscore-dangle*/
import {
  AccountBox,
  CheckBoxOutlineBlank,
  Close,
  Lock,
} from '@material-ui/icons'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom'
import DoorFrontIcon from '@mui/icons-material/DoorFront'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  Divider,
  Grid,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  Tooltip,
  Typography,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { PriorityHigh } from '@mui/icons-material'
import { get } from 'lodash'
import React, { ReactNode, useState } from 'react'
import {
  BooleanField,
  DateField,
  FunctionField,
  Labeled,
  Record,
  RecordContextProvider,
  ReferenceField,
  sanitizeFetchType,
  SimpleShowLayout,
  TextField,
  useQuery,
  useRecordContext,
  useTranslate,
} from 'react-admin'
import camelcaseKeys from 'camelcase-keys'
import { DateTime } from '../../../../core/common/date-time'
import { IOStatusDto } from '../../../../core/dto/device/common/modules/io-status.dto'
import { LiteDto } from '../../../../core/dto/device/common/modules/lite.dto'
import { ModuleBaseDto } from '../../../../core/dto/device/common/modules/module-base.dto'
import { OfflineServerModuleDto } from '../../../../core/dto/device/common/modules/offline-server-module.dto'
import { PresenterDto } from '../../../../core/dto/device/common/modules/presenter.dto'
import { ReaderDto } from '../../../../core/dto/device/common/modules/reader.dto'
import { SensorDto } from '../../../../core/dto/device/common/modules/sensor.dto'
import {
  TurnstileDto,
  TurnstileStatusData,
} from '../../../../core/dto/device/common/modules/turnstile.dto'
import { PinStates } from '../../../../core/enum/device-modues/PinStates'
import { LCDPlusDto } from '../../../../core/dto/device/common/modules/lcd-plus.dto'
import { getModulesFromJsonStatus } from '../../../../core/devices/common/modules/module.mapper'
import {
  isDifferentVersion,
  getContrastColor,
} from '../../../../core/common/visual.utils'
import { DeviceModuleTypes } from '../../../../core/enum/device-modues/DeviceModuleTypes'
import { PrinterDto } from '../../../../core/dto/device/common/modules/printer.dto'
import { DeviceTypes } from '../../../../core/enum/DeviceTypes'
import PaperRoll from '../../../../assets/icons/PaperRoll'
import { ResourceName } from '../../../../core/ResourceName'
import { DepositorDoorStatus } from '../../../../core/enum/DepositorDoorStatus'
import { DepositorLockerStatus } from '../../../../core/enum/DepositorLockerStatus'
import { AutomatAPIStatusDto } from '../../../../core/dto/device/ticket-machines/automat-api/automat-api-status.dto'
import { MDBPoolStatuses } from '../../../../core/enum/ticket-machines/MDBPoolStatuses'
import { MDBDiagnosticStatuses } from '../../../../core/enum/ticket-machines/MDBDiagnosticStatuses'
import { NV200Statuses } from '../../../../core/enum/ticket-machines/NV200Statuses'
import { IksorisParkingTicketMachineStatusDto } from '../../../../core/dto/device/ticket-machines/iksoris-parking-ticket-machine-status.dto'
import { SelfPOSAccessTicketMachineStatusDto } from '../../../../core/dto/device/ticket-machines/selfpos-access-ticket-cashless-machine/selfpos-access-ticket-cashless-machine-status.dto'

import {
  CameraStatusDto,
  HikvisionStatusDto,
} from '../../../../core/dto/device/camera/cameras/camera.dto-status'
import { CameraTypes } from '../../../../core/enum/CameraTypes'
import { CameraServerStatusDto } from '../../../../core/dto/device/camera/camera-servers/camera-server.dto-status'
import {
  CameraHardwareStatusHikvision,
  CameraRecordingStatusHikvision,
  CameraServerHddStatusHikvision,
  CameraServerStatusHikvision,
} from '../../../../core/enum/camera-related/HikvisionStatuses'
import { PrinterTypes } from '../../../../core/enum/ticket-machines/PrinterTypes'
import { BlankActions } from '../../../common/BlankActions'
import { TurnstileStatuses } from '../../../../core/enum/device-modues/TurnstileStatuses'

const moduleHeaderBase = {
  borderTop: 'solid',
  borderRight: 'solid',
  borderLeft: 'solid',
  borderTopRightRadius: 5,
  borderTopLeftRadius: 5,
}

const moduleDetailsBase = {
  borderBottom: 'solid',
  borderRight: 'solid',
  borderLeft: 'solid',
  borderBottomRightRadius: 5,
  borderBottomLeftRadius: 5,
  '& > div': {
    width: '100%',
  },
}

const useStyles = makeStyles((theme: Theme) => ({
  simpleShowLayoutWithNoVerticalPadding: {
    paddingBottom: 0,
    '&:first-child': {
      paddingTop: 0,
    },
    '&:last-child': {
      paddingBottom: 0,
      [theme.breakpoints.only('xs')]: {
        paddingBottom: 0,
      },
    },
  },
  defaultModuleHeader: {
    ...moduleHeaderBase,
    backgroundColor: theme.palette.success.main,
    borderTopColor: theme.palette.success.main,
    borderRightColor: theme.palette.success.main,
    borderLeftColor: theme.palette.success.main,
  },
  defaultModuleDetails: {
    ...moduleDetailsBase,
    borderBottomColor: theme.palette.success.main,
    borderRightColor: theme.palette.success.main,
    borderLeftColor: theme.palette.success.main,
  },
  terminatedModuleHeader: {
    ...moduleHeaderBase,
    backgroundColor: theme.palette.error.main,
    borderTopColor: theme.palette.error.main,
    borderRightColor: theme.palette.error.main,
    borderLeftColor: theme.palette.error.main,
  },
  terminatedModuleDetails: {
    ...moduleDetailsBase,
    borderBottomColor: theme.palette.error.main,
    borderRightColor: theme.palette.error.main,
    borderLeftColor: theme.palette.error.main,
  },
  previewedDeviceOk: {
    borderRadius: 12,
    backgroundColor: theme.palette.success.main,
  },
  previewedDeviceError: {
    borderRadius: 12,
    backgroundColor: theme.palette.error.main,
  },
  iconContainer: {
    position: 'relative',
    width: 34,
  },
  statusIcon: {
    position: 'absolute',
    left: 5,
    top: 5,
    fontSize: '24px !important',
  },
  crossIcon: {
    position: 'absolute',
    left: 0,
    top: 0,
    fontSize: 34,
    opacity: 0.8,
  },
  exclamationIcon: {
    position: 'absolute',
    left: 2.5,
    top: 0,
    fontSize: 34,
  },
  localIcon: {
    fill: theme.palette.text.primary,
  },
  moduleUnderline: {
    textDecoration: 'underline',
    textDecorationColor: 'red',
    textDecorationThickness: '2px',
  },
  moduleBorder: {
    '& svg': {
      border: '2px solid red',
      marginTop: '-2px',
      marginLeft: '-2px',
    },
  },
}))

const CheckLastRefreshError = (
  lastRefresh: DateTime | undefined,
  referenceDateTime: DateTime,
) => {
  if (!lastRefresh) {
    return true
  }
  let moduleStatusTimeout = '00:00:00'
  try {
    moduleStatusTimeout = JSON.parse(
      localStorage?.preferences,
    )?.moduleStatusTimeout
    if (moduleStatusTimeout === null || moduleStatusTimeout === undefined)
      moduleStatusTimeout = '00:01:30'
  } catch {
    moduleStatusTimeout = '00:01:30'
  }
  const timeoutArray = moduleStatusTimeout.split(':')
  const hours = Number(timeoutArray[0])
  const minutes = Number(timeoutArray[1])
  const seconds = Number(timeoutArray[2])
  const timeoutDate = (hours * 3600 + minutes * 60 + seconds) * 1000
  return (
    new Date(lastRefresh).valueOf() <
    new Date(referenceDateTime).valueOf() - timeoutDate
  )
}

const CheckOfflineServerError = (module: OfflineServerModuleDto): boolean => {
  if (module?.module?.typeId !== DeviceModuleTypes.OFFLINE_SERVER) {
    return false
  }

  const { replicationApplierStatus, replicationConnectionStatus } = module
  return !replicationApplierStatus || !replicationConnectionStatus
}

const CheckPrinterError = (module: PrinterDto) => {
  if (!module) return false
  return (
    module.printingHeadUpError ||
    module.coverOpened ||
    module.headTemperatureError ||
    module.powerSupplyVoltageError ||
    module.ramError ||
    module.autocutterError ||
    module.emiterError ||
    module.paperNotPresent ||
    false
  )
}

const CheckDoorError = (module) => {
  if (!module) return false
  return (
    module.isControllerCaseOpen === true ||
    module.fireAlarmActive === true ||
    module.safeButtonPressed === true ||
    false
  )
}

const CheckIksorisParkingTicketCashMachineError = (
  ticketMachineStatus: IksorisParkingTicketMachineStatusDto,
) => {
  if (!ticketMachineStatus) return true
  if (
    !ticketMachineStatus ||
    !ticketMachineStatus?.apiAuthorizationOk ||
    (ticketMachineStatus.isFiscalPrinterInitialized &&
      ticketMachineStatus.fiscalPrinterSupportStatus &&
      !ticketMachineStatus.isFiscalPrinterStatusOk) ||
    (ticketMachineStatus.isFiscalPrinterInitialized &&
      !ticketMachineStatus.isFiscalPrinterOk) ||
    ticketMachineStatus.fiscalPrinterPaperEnd ||
    !ticketMachineStatus.isBarcodeReaderOk ||
    !ticketMachineStatus.isCashOk ||
    (ticketMachineStatus.isKioskPrinterInitialized &&
      ticketMachineStatus.kioskPrinterSupportStatus &&
      !ticketMachineStatus.isKioskPrinterStatusOk) ||
    (ticketMachineStatus.isKioskPrinterInitialized &&
      !ticketMachineStatus.isKioskPrinterOk) ||
    ticketMachineStatus.kioskPrinterPaperEnd ||
    !ticketMachineStatus.isTerminalOk ||
    (ticketMachineStatus.isTicketPrinterInitialized &&
      ticketMachineStatus.ticketPrinterSupportStatus &&
      !ticketMachineStatus.isTicketPrinterStatusOk) ||
    (ticketMachineStatus.isTicketPrinterInitialized &&
      !ticketMachineStatus.isTicketPrinterOk) ||
    ticketMachineStatus.ticketPrinterPaperEnd
  )
    return true
  return false
}

const CheckIksorisParkingTicketCashlessMachineError = (
  ticketMachineStatus: IksorisParkingTicketMachineStatusDto,
) => {
  if (!ticketMachineStatus) return true
  if (
    !ticketMachineStatus ||
    !ticketMachineStatus?.apiAuthorizationOk ||
    (ticketMachineStatus.isFiscalPrinterInitialized &&
      ticketMachineStatus.fiscalPrinterSupportStatus &&
      !ticketMachineStatus.isFiscalPrinterStatusOk) ||
    (ticketMachineStatus.isFiscalPrinterInitialized &&
      !ticketMachineStatus.isFiscalPrinterOk) ||
    ticketMachineStatus.fiscalPrinterPaperEnd ||
    !ticketMachineStatus.isBarcodeReaderOk ||
    (ticketMachineStatus.isKioskPrinterInitialized &&
      ticketMachineStatus.kioskPrinterSupportStatus &&
      !ticketMachineStatus.isKioskPrinterStatusOk) ||
    (ticketMachineStatus.isKioskPrinterInitialized &&
      !ticketMachineStatus.isKioskPrinterOk) ||
    ticketMachineStatus.kioskPrinterPaperEnd ||
    !ticketMachineStatus.isTerminalOk ||
    (ticketMachineStatus.isTicketPrinterInitialized &&
      ticketMachineStatus.ticketPrinterSupportStatus &&
      !ticketMachineStatus.isTicketPrinterStatusOk) ||
    (ticketMachineStatus.isTicketPrinterInitialized &&
      !ticketMachineStatus.isTicketPrinterOk) ||
    ticketMachineStatus.ticketPrinterPaperEnd
  )
    return true
  return false
}

const CheckAutomatAPIError = (
  automatApiStatus: AutomatAPIStatusDto,
): boolean => {
  if (
    !automatApiStatus?.currenzaMdbChanger ||
    !automatApiStatus?.nV200NotePayout
  )
    return true

  const changer = automatApiStatus.currenzaMdbChanger
  const payout = automatApiStatus.nV200NotePayout

  const mdbStatusErrors = [
    MDBPoolStatuses.COIN_ROUTING_ERROR,
    MDBPoolStatuses.DEFECTIVE_TUBE_SENSOR,
    MDBPoolStatuses.ACCEPTOR_UNPLUGGED,
    MDBPoolStatuses.COIN_JAM,
    MDBPoolStatuses.ROM_CHECKSUM_ERROR,
    MDBPoolStatuses.TUBE_JAM,
  ]

  const mdbDiagnosticErrors = [
    MDBDiagnosticStatuses.ACCEPT_GATE_MODULE_ERROR,
    MDBDiagnosticStatuses.ACCEPT_GATE_MODULE_ERROR_ALARM_ACTIVE,
    MDBDiagnosticStatuses.ACCEPT_GATE_MODULE_ERROR_COIN_ENTERED_GATE_BUT_NOT_EXIT,
    MDBDiagnosticStatuses.ACCEPT_GATE_MODULE_ERROR_GATE_OPENED_BUT_NO_COIN_DETECTED,
    MDBDiagnosticStatuses.ACCEPT_GATE_MODULE_ERROR_POST_GATE_SENSOR_COVERED_BEFORE_GATE_OPENED,
    MDBDiagnosticStatuses.COIN_CASSETTE_OR_TUBE_MODULE_ERROR,
    MDBDiagnosticStatuses.COIN_CASSETTE_OR_TUBE_MODULE_ERROR_CASHBOX_SENSOR_ERROR,
    MDBDiagnosticStatuses.COIN_CASSETTE_OR_TUBE_MODULE_ERROR_CASSETE_REMOVED,
    MDBDiagnosticStatuses.COIN_CASSETTE_OR_TUBE_MODULE_ERROR_SUNLIGHT_ON_TUBE_SENSORS,
    MDBDiagnosticStatuses.DISCRIMINATOR_MODULE_ERROR,
    MDBDiagnosticStatuses.DISCRIMINATOR_MODULE_ERROR_COIN_JAM_IN_SENSOR,
    MDBDiagnosticStatuses.DISCRIMINATOR_MODULE_ERROR_DISCRIMINATOR_BELOW_STANDARD,
    MDBDiagnosticStatuses.DISCRIMINATOR_MODULE_ERROR_ESCROW_RETURN_STUCK_OPEN,
    MDBDiagnosticStatuses.DISCRIMINATOR_MODULE_ERROR_FLIGHT_DECK_OPEN,
    MDBDiagnosticStatuses.DISCRIMINATOR_MODULE_ERROR_SENSOR_A_OUT_OF_RANGE,
    MDBDiagnosticStatuses.DISCRIMINATOR_MODULE_ERROR_SENSOR_B_OUT_OF_RANGE,
    MDBDiagnosticStatuses.DISCRIMINATOR_MODULE_ERROR_SENSOR_C_OUT_OF_RANGE,
    MDBDiagnosticStatuses.DISCRIMINATOR_MODULE_ERROR_SIZING_OPTICS_FAILURE,
    MDBDiagnosticStatuses.DISCRIMINATOR_MODULE_ERROR_TEMPERATURE_EXCEEDED,
    MDBDiagnosticStatuses.DISPENSER_MODULE_ERROR,
    MDBDiagnosticStatuses.GENERAL_CHANGER_ERROR,
    MDBDiagnosticStatuses.GENERAL_CHANGER_ERROR_CHECKSUM_1,
    MDBDiagnosticStatuses.GENERAL_CHANGER_ERROR_CHECKSUM_2,
    MDBDiagnosticStatuses.GENERAL_CHANGER_ERROR_LOW_LINE_VOLTAGE,
    MDBDiagnosticStatuses.SEPARATOR_MODULE_ERROR,
    MDBDiagnosticStatuses.SEPARATOR_MODULE_ERROR_SORT_SENSOR_ERROR,
  ]

  const nv200Errors = [
    NV200Statuses._5,
    NV200Statuses._9,
    NV200Statuses._16,
    NV200Statuses._48,
    NV200Statuses._99,
  ]

  const hasStatusError =
    changer.enabled &&
    changer.statuses?.some((status) => mdbStatusErrors.includes(status))

  const hasDiagnosticError =
    changer.enabled &&
    (!changer.diagnosticStatuses ||
      changer.diagnosticStatuses.some((status) =>
        mdbDiagnosticErrors.includes(status),
      ))

  const hasNV200Error =
    payout.enabled &&
    (!payout.statuses ||
      payout.statuses.some((status) => nv200Errors.includes(status)))

  return hasStatusError || hasDiagnosticError || hasNV200Error
}

const CheckSelfPOSAPIError = (
  selfPOSApiStatus: SelfPOSAccessTicketMachineStatusDto,
) => {
  const printers = [
    selfPOSApiStatus?.ticketPrinter,
    selfPOSApiStatus?.receiptPrinter,
    selfPOSApiStatus?.paymentConfirmationPrinter,
  ]

  const hasPrinterError = printers.some((printer) => {
    if (!printer || !printer?.type) return true
    if (!printer?.status || printer.type === PrinterTypes.NO_PRINTER)
      return false
    return printer.status.startsWith('ERROR')
  })

  if (hasPrinterError) return true
  return false
}

const CheckCameraError = (
  cameraStatus: CameraStatusDto,
  cameraType: CameraTypes,
) => {
  if (!cameraStatus) return true
  if (cameraType === CameraTypes.HIKVISION_RTSP) {
    if (
      !cameraStatus?.hikvisionCameraStatus?.isOnline ||
      !cameraStatus?.hikvisionCameraStatus?.isRecording ||
      cameraStatus?.hikvisionCameraStatus?.recordingStatus !==
        CameraRecordingStatusHikvision.OK ||
      cameraStatus?.hikvisionCameraStatus?.hardwareStatus !==
        CameraHardwareStatusHikvision.NORMAL
    )
      return true
    return false
  }
  return true
}

const CheckCameraServerError = (
  cameraServerStatus: CameraServerStatusDto,
  cameraType: CameraTypes,
) => {
  if (!cameraServerStatus) return true
  if (cameraType === CameraTypes.HIKVISION_RTSP) {
    if (
      !cameraServerStatus?.hikvisionServerStatus?.deviceStatus ||
      cameraServerStatus?.hikvisionServerStatus?.deviceStatus !==
        CameraServerStatusHikvision.OK
    )
      return true

    return cameraServerStatus?.hikvisionServerStatus?.hddStatuses.some(
      (hdd) => hdd?.status !== CameraServerHddStatusHikvision.OK,
    )
  }
  return true
}

const CheckModulesError = (
  modules: ModuleBaseDto[],
  referenceDateTime: DateTime,
) => {
  if (
    modules.some(
      (module) =>
        CheckLastRefreshError(module.lastRefresh, referenceDateTime) ||
        CheckOfflineServerError(module),
    )
  )
    return true
  return false
}

const ModuleStatusBase = (props: ModuleBaseStatusProps) => {
  const translate = useTranslate()
  const classes = useStyles()
  const { moduleInfo, disableAliasHeader, children } = props
  const [versionAPI, setVersionAPI] = useState<undefined | string>(undefined)
  const convertedSerialNumber = Number(
    moduleInfo.identity?.serialNumber,
  ).toString(16)
  const originalProductionVersion = Number(
    moduleInfo.identity?.version.productionVersion,
  )
  /* eslint-disable no-bitwise */
  const convertedProductionVersion = `${
    (originalProductionVersion >> 8) & 0xff
  }.${originalProductionVersion & 0xff}`
  const convertedModuleInfo = {
    ...moduleInfo,
    identity: moduleInfo.identity && {
      ...moduleInfo.identity,
      serialNumber: moduleInfo.identity?.serialNumber
        ? convertedSerialNumber
        : undefined,
      version: {
        ...moduleInfo.identity.version,
        productionVersion: originalProductionVersion
          ? convertedProductionVersion
          : undefined,
      },
    },
  }

  useQuery(
    {
      type: sanitizeFetchType('getAPIVersion'),
      resource: ResourceName.CURRENT_USER,
      payload: {},
    },
    {
      // enable only for Offline Servers
      enabled: !versionAPI && !!moduleInfo?.identity?.version?.version,
      onSuccess: (data) =>
        data?.data?.version && setVersionAPI(data.data.version),
    },
  )

  const Body = ({ ...childrenProps }) => {
    const moduleRecord = useRecordContext<ModuleBaseDto>()

    return (
      <Grid
        container
        direction="row"
        justify="space-around"
        alignItems="flex-start"
      >
        {children !== undefined &&
          children.map((child, index) => {
            if (child !== false) {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <Grid item key={index} md={2} sm={4} xs={12}>
                  <RecordContextProvider value={convertedModuleInfo}>
                    {child}
                  </RecordContextProvider>
                </Grid>
              )
            }
            return undefined
          })}
        <Grid item key="base-module-divider" xs={12}>
          <Divider />
        </Grid>
        <Grid item key="base-module-typeId" md={2} sm={4} xs={12}>
          <SimpleShowLayout
            {...childrenProps}
            className={classes.simpleShowLayoutWithNoVerticalPadding}
          >
            <FunctionField<ModuleBaseDto>
              source="module.typeId"
              render={(record?: ModuleBaseDto) => (
                <div>
                  {translate(
                    `resources.enums.module.deviceModuleTypes.${record?.module?.typeId}`,
                  )}
                </div>
              )}
            />
          </SimpleShowLayout>
        </Grid>
        {moduleRecord.module.address && (
          <Grid item key="base-module-address" md={2} sm={4} xs={12}>
            <SimpleShowLayout
              {...childrenProps}
              className={classes.simpleShowLayoutWithNoVerticalPadding}
            >
              <TextField source="module.address" />
            </SimpleShowLayout>
          </Grid>
        )}
        <Grid item key="base-module-lastRefresh" md={2} sm={4} xs={12}>
          <SimpleShowLayout
            {...childrenProps}
            className={classes.simpleShowLayoutWithNoVerticalPadding}
          >
            <DateField
              source="lastRefresh"
              showTime
              options={{
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
              }}
            />
          </SimpleShowLayout>
        </Grid>
        {moduleRecord.identity?.serialNumber && (
          <Grid item key="base-module-serialNumber" md={2} sm={4} xs={12}>
            <SimpleShowLayout
              {...childrenProps}
              className={classes.simpleShowLayoutWithNoVerticalPadding}
            >
              <TextField source="identity.serialNumber" />
            </SimpleShowLayout>
          </Grid>
        )}
        {moduleRecord.identity?.version?.productionVersion && (
          <Grid item key="base-module-productionVersion" md={2} sm={4} xs={12}>
            <SimpleShowLayout
              {...childrenProps}
              className={classes.simpleShowLayoutWithNoVerticalPadding}
            >
              <TextField source="identity.version.productionVersion" />
            </SimpleShowLayout>
          </Grid>
        )}
        {moduleRecord.identity?.version?.develVersion !== undefined && (
          <Grid item key="base-module-develVersion" md={2} sm={4} xs={12}>
            <SimpleShowLayout
              {...childrenProps}
              className={classes.simpleShowLayoutWithNoVerticalPadding}
            >
              <Labeled source="identity.version.develVersion">
                <FunctionField<ModuleBaseDto>
                  source="identity.version.develVersion"
                  render={(record?: ModuleBaseDto, source?: string) =>
                    get(record, source as string) !== 0
                      ? get(record, source as string)
                      : '-'
                  }
                />
              </Labeled>
            </SimpleShowLayout>
          </Grid>
        )}
        {moduleRecord.identity?.version?.version && (
          <Grid item key="base-module-version" md={2} sm={4} xs={12}>
            <FunctionField
              render={() =>
                moduleRecord.identity?.version?.version ? (
                  <SimpleShowLayout
                    {...childrenProps}
                    className={classes.simpleShowLayoutWithNoVerticalPadding}
                  >
                    <TextField
                      className={
                        versionAPI &&
                        isDifferentVersion(
                          versionAPI,
                          moduleRecord.identity.version.version,
                        )
                          ? classes.moduleUnderline
                          : ''
                      }
                      source="identity.version.version"
                    />
                  </SimpleShowLayout>
                ) : undefined
              }
              onClick={(e) => e.stopPropagation()}
            />
          </Grid>
        )}
      </Grid>
    )
  }

  return (
    <RecordContextProvider value={convertedModuleInfo}>
      <SimpleShowLayout resource="modules">
        {!disableAliasHeader && (
          <>
            <Box marginBottom={1}>
              <TextField variant="h6" source="module.alias" />
            </Box>
          </>
        )}
        <Body />
      </SimpleShowLayout>
    </RecordContextProvider>
  )
}

const ModuleStatus = (props: ModuleStatusProps) => {
  const { moduleInfo, statusIndex, reversedDirection } = props
  const translate = useTranslate()
  const classes = useStyles()
  const turnstileStatusDataLength = (moduleInfo as TurnstileDto)
    ?.turnstileStatusData?.length
  let convertedStatusIndex = 0
  if (
    turnstileStatusDataLength &&
    turnstileStatusDataLength > 0 &&
    statusIndex !== undefined &&
    statusIndex < turnstileStatusDataLength
  ) {
    convertedStatusIndex = statusIndex
  }
  const turnstileData =
    turnstileStatusDataLength === undefined
      ? (moduleInfo as TurnstileStatusData)
      : (moduleInfo as TurnstileDto)?.turnstileStatusData?.[
          convertedStatusIndex
        ]

  return (
    <ModuleStatusBase {...props}>
      {/* IOStatusDto */}
      {(moduleInfo as IOStatusDto)?.fireAlarms !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <Labeled source="fireAlarms.title">
            <>
              <TableContainer component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">
                        {translate('resources.modules.fields.fireAlarms.zone')}
                      </TableCell>
                      <TableCell align="center">
                        {translate('resources.modules.fields.fireAlarms.state')}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {((moduleInfo as IOStatusDto)?.fireAlarms as boolean[]).map(
                      (value, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <TableRow key={index}>
                          <TableCell align="center">
                            {(index + 1).toString()}
                          </TableCell>
                          <TableCell align="center">
                            <Checkbox style={{ padding: 0 }} checked={value} />
                          </TableCell>
                        </TableRow>
                      ),
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          </Labeled>
        </SimpleShowLayout>
      )}
      {(moduleInfo as IOStatusDto)?.allPortsStates !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <Labeled source="allPortsStates.title">
            <>
              <TableContainer component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">
                        {translate(
                          'resources.modules.fields.allPortsStates.pin',
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {translate(
                          'resources.modules.fields.allPortsStates.state',
                        )}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(
                      (moduleInfo as IOStatusDto)?.allPortsStates as PinStates[]
                    ).map((value, index) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <TableRow key={index}>
                        <TableCell align="center">
                          {(index + 1).toString()}
                        </TableCell>
                        <TableCell align="center">
                          <Typography>
                            {translate(
                              `resources.enums.module.pinStates.${value}`,
                            )}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          </Labeled>
        </SimpleShowLayout>
      )}

      {/* TurnstileDto */}
      {turnstileData?.forwardStatus !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
          record={turnstileData}
        >
          <FunctionField<TurnstileStatusData>
            className={
              [TurnstileStatuses.ERROR, TurnstileStatuses.UNAUTH].includes(
                turnstileData?.forwardStatus,
              )
                ? classes.moduleUnderline
                : ''
            }
            source="forwardStatus"
            render={(record?: TurnstileStatusData) => (
              <div>
                {translate(
                  `resources.enums.module.turnstileStatuses.${record?.forwardStatus}`,
                )}
              </div>
            )}
          />
        </SimpleShowLayout>
      )}
      {turnstileData?.backwardStatus !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
          record={turnstileData}
        >
          <FunctionField<TurnstileStatusData>
            className={
              [TurnstileStatuses.ERROR, TurnstileStatuses.UNAUTH].includes(
                turnstileData?.backwardStatus,
              )
                ? classes.moduleUnderline
                : ''
            }
            source="backwardStatus"
            render={(record?: TurnstileStatusData) => (
              <div>
                {translate(
                  `resources.enums.module.turnstileStatuses.${record?.backwardStatus}`,
                )}
              </div>
            )}
          />
        </SimpleShowLayout>
      )}
      {turnstileData?.fireAlarm !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
          record={turnstileData}
        >
          <BooleanField source="fireAlarm" />
        </SimpleShowLayout>
      )}
      {turnstileData?.fireAlarmType !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
          record={turnstileData}
        >
          <FunctionField<TurnstileStatusData>
            source="fireAlarmType"
            render={(record?: TurnstileStatusData) => (
              <div>
                {translate(
                  `resources.enums.module.turnstileInputTypes.${record?.fireAlarmType}`,
                )}
              </div>
            )}
          />
        </SimpleShowLayout>
      )}
      {turnstileData?.powerTurnedOn !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
          record={turnstileData}
        >
          <BooleanField
            className={
              !(turnstileData as TurnstileStatusData)?.powerTurnedOn
                ? classes.moduleBorder
                : ''
            }
            source="powerTurnedOn"
          />
        </SimpleShowLayout>
      )}
      {turnstileData?.freePassForward !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
          record={turnstileData}
        >
          <BooleanField source="freePassForward" />
        </SimpleShowLayout>
      )}
      {turnstileData?.freePassBackward !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
          record={turnstileData}
        >
          <BooleanField source="freePassBackward" />
        </SimpleShowLayout>
      )}
      {turnstileData?.keyLock !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
          record={turnstileData}
        >
          <FunctionField<TurnstileStatusData>
            source="keyLock"
            render={(record?: TurnstileStatusData) => (
              <div>
                {translate(
                  `resources.enums.module.keyLockStatuses.${record?.keyLock}`,
                )}
              </div>
            )}
          />
        </SimpleShowLayout>
      )}
      {turnstileData?.tamperLock !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
          record={turnstileData}
        >
          <BooleanField source="tamperLock" />
        </SimpleShowLayout>
      )}
      {reversedDirection !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
          record={{ ...turnstileData, reversedDirection } as Record}
        >
          <BooleanField
            source="reversedDirection"
            label="resources.modules.fields.directionReversed"
          />
        </SimpleShowLayout>
      )}
      {turnstileData?.turnstileControllerError !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
          record={turnstileData}
        >
          <FunctionField<TurnstileStatusData>
            source="turnstileControllerError"
            render={(record?: TurnstileStatusData) => (
              <BooleanField
                className={
                  record?.turnstileControllerError ? classes.moduleBorder : ''
                }
                source="turnstileControllerError"
                record={{
                  ...(record as TurnstileStatusData),
                  turnstileControllerError: !record?.turnstileControllerError,
                }}
              />
            )}
          />
        </SimpleShowLayout>
      )}

      {/* LiteDto */}
      {(moduleInfo as LiteDto)?.ledsColor !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
          record={turnstileData}
        >
          <Labeled source="ledsColor">
            <>
              <Box
                p={1}
                borderRadius={10}
                color={
                  (moduleInfo as LiteDto)?.ledsColor &&
                  Number((moduleInfo as LiteDto).ledsColor) > 0
                    ? getContrastColor(
                        `#${(moduleInfo as LiteDto)?.ledsColor?.toString(16)}`,
                      )
                    : '#ffffff'
                }
                bgcolor={
                  (moduleInfo as LiteDto)?.ledsColor &&
                  Number((moduleInfo as LiteDto).ledsColor) > 0
                    ? `#${(moduleInfo as LiteDto)?.ledsColor?.toString(16)}`
                    : '#000000'
                }
              >
                <Typography>
                  #{(moduleInfo as LiteDto).ledsColor?.toString(16)}
                </Typography>
              </Box>
            </>
          </Labeled>
        </SimpleShowLayout>
      )}

      {/* ReaderDto */}
      {(moduleInfo as ReaderDto)?.isPresenterActive !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <BooleanField source="isPresenterActive" />
        </SimpleShowLayout>
      )}
      {(moduleInfo as ReaderDto)?.standbyMode !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <FunctionField<ReaderDto>
            source="standbyMode"
            render={(record?: ReaderDto) => (
              <div>
                {translate(
                  `resources.enums.module.stanbyModeNumeric.${record?.standbyMode}`,
                )}
              </div>
            )}
          />
        </SimpleShowLayout>
      )}
      {(moduleInfo as ReaderDto)?.sensorId !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <FunctionField<ReaderDto>
            source="sensorId"
            render={(record?: ReaderDto) => (
              <Typography>{record?.sensorId?.toString(16)}</Typography>
            )}
          />
        </SimpleShowLayout>
      )}
      {(moduleInfo as ReaderDto)?.errors?.scannerError !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <BooleanField
            className={
              (moduleInfo as ReaderDto)?.errors?.scannerError
                ? classes.moduleBorder
                : ''
            }
            source="errors.scannerError"
          />
        </SimpleShowLayout>
      )}
      {(moduleInfo as ReaderDto)?.errors?.mifareError !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <BooleanField
            className={
              (moduleInfo as ReaderDto)?.errors?.mifareError
                ? classes.moduleBorder
                : ''
            }
            source="errors.mifareError"
          />
        </SimpleShowLayout>
      )}
      {(moduleInfo as ReaderDto)?.errors?.flashError !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <BooleanField
            className={
              (moduleInfo as ReaderDto)?.errors?.flashError
                ? classes.moduleBorder
                : ''
            }
            source="errors.flashError"
          />
        </SimpleShowLayout>
      )}
      {(moduleInfo as ReaderDto)?.errors?.sdCardError !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <BooleanField
            className={
              (moduleInfo as ReaderDto)?.errors?.sdCardError
                ? classes.moduleBorder
                : ''
            }
            source="errors.sdCardError"
          />
        </SimpleShowLayout>
      )}
      {(moduleInfo as ReaderDto)?.errors?.licenceError !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <BooleanField
            className={
              (moduleInfo as ReaderDto)?.errors?.licenceError
                ? classes.moduleBorder
                : ''
            }
            source="errors.licenceError"
          />
        </SimpleShowLayout>
      )}
      {(moduleInfo as ReaderDto)?.errors?.scannerFirmwareError !==
        undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <BooleanField
            className={
              (moduleInfo as ReaderDto)?.errors?.scannerFirmwareError
                ? classes.moduleBorder
                : ''
            }
            source="errors.scannerFirmwareError"
          />
        </SimpleShowLayout>
      )}

      {/* PresenterDto */}
      {(moduleInfo as PresenterDto)?.contentType !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <FunctionField<PresenterDto>
            source="contentType"
            render={(record?: PresenterDto) => (
              <div>
                {translate(
                  `resources.enums.module.contentTypes.${record?.contentType}`,
                )}
              </div>
            )}
          />
        </SimpleShowLayout>
      )}
      {(moduleInfo as PresenterDto)?.contentNumber !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <TextField source="contentNumber" />
        </SimpleShowLayout>
      )}
      {(moduleInfo as PresenterDto)?.contrast !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <FunctionField<PresenterDto>
            source="contrast"
            render={() => (
              <Grid container alignItems="baseline">
                <TextField source="contrast" />
                <Typography>%</Typography>
              </Grid>
            )}
          />
        </SimpleShowLayout>
      )}

      {/* SensorDto */}
      {(moduleInfo as SensorDto)?.temperature !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <FunctionField<SensorDto>
            source="temperature"
            render={() => (
              <Grid container alignItems="baseline">
                <TextField source="temperature" />
                <Typography>&deg;C</Typography>
              </Grid>
            )}
          />
        </SimpleShowLayout>
      )}
      {(moduleInfo as SensorDto)?.humidity !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <FunctionField<SensorDto>
            source="humidity"
            render={() => (
              <Grid container alignItems="baseline">
                <TextField source="humidity" />
                <Typography>%</Typography>
              </Grid>
            )}
          />
        </SimpleShowLayout>
      )}
      {(moduleInfo as SensorDto)?.move !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <FunctionField<SensorDto>
            source="move"
            render={(record?: SensorDto) => (
              <div>
                {translate(
                  `resources.enums.module.moveSensorStatuses.${record?.move}`,
                )}
              </div>
            )}
          />
        </SimpleShowLayout>
      )}
      {(moduleInfo as SensorDto)?.light !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <FunctionField<SensorDto>
            source="light"
            render={(record?: SensorDto) => (
              <Typography>
                {translate(
                  `resources.enums.module.lightLevels.${record?.light}`,
                )}
              </Typography>
            )}
          />
        </SimpleShowLayout>
      )}
      {(moduleInfo as SensorDto)?.fan !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <FunctionField<SensorDto>
            source="fan"
            render={(record?: SensorDto) => (
              <Typography>
                {translate(
                  `resources.enums.module.fanHeaterStatuses.${record?.fan}`,
                )}
              </Typography>
            )}
          />
        </SimpleShowLayout>
      )}
      {(moduleInfo as SensorDto)?.heater !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <FunctionField<SensorDto>
            source="heater"
            render={(record?: SensorDto) => (
              <Typography>
                {translate(
                  `resources.enums.module.fanHeaterStatuses.${record?.heater}`,
                )}
              </Typography>
            )}
          />
        </SimpleShowLayout>
      )}
      {(moduleInfo as SensorDto)?.moveSensorTimeout !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <FunctionField<SensorDto>
            source="moveSensorTimeout"
            render={() => (
              <Grid container alignItems="baseline">
                <TextField source="moveSensorTimeout" />
                <Typography>s</Typography>
              </Grid>
            )}
          />
        </SimpleShowLayout>
      )}

      {/* OfflineServerModuleDto */}
      {(moduleInfo as OfflineServerModuleDto)?.replicationApplierStatus !==
        undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <BooleanField source="replicationApplierStatus" />
        </SimpleShowLayout>
      )}
      {(moduleInfo as OfflineServerModuleDto)?.replicationConnectionStatus !==
        undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <BooleanField source="replicationConnectionStatus" />
        </SimpleShowLayout>
      )}
      {(moduleInfo as OfflineServerModuleDto)?.queueLength !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <TextField source="queueLength" />
        </SimpleShowLayout>
      )}
      {(moduleInfo as OfflineServerModuleDto)?.secondsBehindMaster !==
        undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <TextField source="secondsBehindMaster" />
        </SimpleShowLayout>
      )}

      {/* LCDPlusDto */}
      {(moduleInfo as LCDPlusDto)?.fanRpm !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <TextField source="fanRpm" />
        </SimpleShowLayout>
      )}
      {(moduleInfo as LCDPlusDto)?.voltage !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <FunctionField<LCDPlusDto>
            source="voltage"
            render={(record?: LCDPlusDto, source?: string) =>
              `${record?.[source as string]} V`
            }
          />
        </SimpleShowLayout>
      )}
      {(moduleInfo as LCDPlusDto)?.turnstileErrorNumber !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <TextField source="turnstileErrorNumber" />
        </SimpleShowLayout>
      )}
      {(moduleInfo as LCDPlusDto)?.turnstileErrorSource !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <TextField source="turnstileErrorSource" />
        </SimpleShowLayout>
      )}
      {(moduleInfo as LCDPlusDto)?.contentLedNumber !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <TextField source="contentLedNumber" />
        </SimpleShowLayout>
      )}
      {(moduleInfo as LCDPlusDto)?.contentBuzzerNumber !== undefined && (
        <SimpleShowLayout
          resource="modules"
          className={classes.simpleShowLayoutWithNoVerticalPadding}
        >
          <TextField source="contentBuzzerNumber" />
        </SimpleShowLayout>
      )}
    </ModuleStatusBase>
  )
}

const MultiModuleStatus = (props: MultiModuleStatusProps) => {
  const classes = useStyles()
  const { moduleInfo, statusIndex, reversedDirection, referenceDateTime } =
    props

  return (
    <>
      {moduleInfo.map((record) => (
        <>
          <Accordion key={record.id}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              className={
                CheckModulesError([record], referenceDateTime)
                  ? classes.terminatedModuleHeader
                  : classes.defaultModuleHeader
              }
            >
              <RecordContextProvider value={record}>
                <TextField variant="h6" source="module.alias" />
              </RecordContextProvider>
            </AccordionSummary>
            <AccordionDetails
              className={
                CheckModulesError([record], referenceDateTime)
                  ? classes.terminatedModuleDetails
                  : classes.defaultModuleDetails
              }
            >
              <ModuleStatus
                moduleInfo={record}
                statusIndex={statusIndex}
                reversedDirection={reversedDirection}
                disableAliasHeader
              />
            </AccordionDetails>
          </Accordion>
          <BlankActions />
        </>
      ))}
    </>
  )
}

const TerminalStatus = ({ ...props }) => {
  const { deviceStatus } = props
  const { printerStatus } = deviceStatus
  const classes = useStyles()
  const translate = useTranslate()

  const paperTooltip = () => {
    if (
      !(printerStatus as PrinterDto)?.paperNotPresent &&
      !(printerStatus as PrinterDto)?.lowPaper
    )
      return translate('resources.enums.printerPaperStatuses.ok')
    if ((printerStatus as PrinterDto)?.paperNotPresent)
      return translate('resources.enums.printerPaperStatuses.paperNotPresent')
    return translate('resources.enums.printerPaperStatuses.lowPaper')
  }

  return (
    <>
      <Accordion key="printer">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          className={
            CheckPrinterError(printerStatus)
              ? classes.terminatedModuleHeader
              : classes.defaultModuleHeader
          }
        >
          <Typography variant="h6">Printer</Typography>
        </AccordionSummary>
        <AccordionDetails
          className={
            CheckPrinterError(printerStatus)
              ? classes.terminatedModuleDetails
              : classes.defaultModuleDetails
          }
        >
          <Grid
            container
            direction="row"
            justify="space-around"
            alignItems="flex-start"
          >
            {(printerStatus as PrinterDto)?.paperNotPresent !== undefined &&
              (printerStatus as PrinterDto)?.lowPaper !== undefined && (
                <SimpleShowLayout
                  resource="modules"
                  className={classes.simpleShowLayoutWithNoVerticalPadding}
                >
                  <FunctionField
                    source="paperStatus"
                    render={() => (
                      <Tooltip title={paperTooltip()}>
                        <div className={classes.iconContainer}>
                          <>
                            <PaperRoll
                              style={{
                                fill: 'transparent',
                                alignSelf: 'center',
                                opacity:
                                  printerStatus?.paperNotPresent ||
                                  printerStatus?.lowPaper
                                    ? 0.5
                                    : 1,
                              }}
                              className={classes.statusIcon}
                            />
                            {printerStatus?.paperNotPresent && (
                              <Close
                                fontSize="large"
                                className={classes.crossIcon}
                              />
                            )}
                            {!printerStatus?.paperNotPresent &&
                              printerStatus?.lowPaper && (
                                <PriorityHigh
                                  fontSize="large"
                                  className={classes.exclamationIcon}
                                />
                              )}
                          </>
                        </div>
                      </Tooltip>
                    )}
                  />
                </SimpleShowLayout>
              )}
            {(printerStatus as PrinterDto)?.autocutterCoverOpened !==
              undefined && (
              <SimpleShowLayout
                resource="modules"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={printerStatus}
              >
                <BooleanField source="autocutterCoverOpened" />
              </SimpleShowLayout>
            )}
            {(printerStatus as PrinterDto)?.autocutterError !== undefined && (
              <SimpleShowLayout
                resource="modules"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={printerStatus}
              >
                <BooleanField source="autocutterError" />
              </SimpleShowLayout>
            )}
            {(printerStatus as PrinterDto)?.blackMarkNotOverSensor !==
              undefined && (
              <SimpleShowLayout
                resource="modules"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={printerStatus}
              >
                <BooleanField source="blackMarkNotOverSensor" />
              </SimpleShowLayout>
            )}
            {(printerStatus as PrinterDto)?.blackMarkSearchError !==
              undefined && (
              <SimpleShowLayout
                resource="modules"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={printerStatus}
              >
                <BooleanField source="blackMarkSearchError" />
              </SimpleShowLayout>
            )}
            {(printerStatus as PrinterDto)?.coverOpened !== undefined && (
              <SimpleShowLayout
                resource="modules"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={printerStatus}
              >
                <BooleanField source="coverOpened" />
              </SimpleShowLayout>
            )}
            {(printerStatus as PrinterDto)?.dragPaperMotorOn !== undefined && (
              <SimpleShowLayout
                resource="modules"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={printerStatus}
              >
                <BooleanField source="dragPaperMotorOn" />
              </SimpleShowLayout>
            )}
            {(printerStatus as PrinterDto)?.eepromError !== undefined && (
              <SimpleShowLayout
                resource="modules"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={printerStatus}
              >
                <BooleanField source="eepromError" />
              </SimpleShowLayout>
            )}
            {(printerStatus as PrinterDto)?.emiterError !== undefined && (
              <SimpleShowLayout
                resource="modules"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={printerStatus}
              >
                <BooleanField source="emiterError" />
              </SimpleShowLayout>
            )}
            {(printerStatus as PrinterDto)?.emitterMotorOff !== undefined && (
              <SimpleShowLayout
                resource="modules"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={printerStatus}
              >
                <BooleanField source="emitterMotorOff" />
              </SimpleShowLayout>
            )}
            {(printerStatus as PrinterDto)?.ffkeyPressed !== undefined && (
              <SimpleShowLayout
                resource="modules"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={printerStatus}
              >
                <BooleanField source="ffkeyPressed" />
              </SimpleShowLayout>
            )}
            {(printerStatus as PrinterDto)?.headTemperatureError !==
              undefined && (
              <SimpleShowLayout
                resource="modules"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={printerStatus}
              >
                <BooleanField source="headTemperatureError" />
              </SimpleShowLayout>
            )}
            {(printerStatus as PrinterDto)?.lfKeyPressed !== undefined && (
              <SimpleShowLayout
                resource="modules"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={printerStatus}
              >
                <BooleanField source="lfKeyPressed" />
              </SimpleShowLayout>
            )}
            {(printerStatus as PrinterDto)?.noAckCommandError !== undefined && (
              <SimpleShowLayout
                resource="modules"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={printerStatus}
              >
                <BooleanField source="noAckCommandError" />
              </SimpleShowLayout>
            )}
            {(printerStatus as PrinterDto)?.paperJam !== undefined && (
              <SimpleShowLayout
                resource="modules"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={printerStatus}
              >
                <BooleanField source="paperJam" />
              </SimpleShowLayout>
            )}
            {(printerStatus as PrinterDto)?.powerSupplyVoltageError !==
              undefined && (
              <SimpleShowLayout
                resource="modules"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={printerStatus}
              >
                <BooleanField source="powerSupplyVoltageError" />
              </SimpleShowLayout>
            )}
            {(printerStatus as PrinterDto)?.printingHeadUpError !==
              undefined && (
              <SimpleShowLayout
                resource="modules"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={printerStatus}
              >
                <BooleanField source="printingHeadUpError" />
              </SimpleShowLayout>
            )}
            {(printerStatus as PrinterDto)?.ramError !== undefined && (
              <SimpleShowLayout
                resource="modules"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={printerStatus}
              >
                <BooleanField source="ramError" />
              </SimpleShowLayout>
            )}
            {(printerStatus as PrinterDto)?.rs232ComError !== undefined && (
              <SimpleShowLayout
                resource="modules"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={printerStatus}
              >
                <BooleanField source="rs232ComError" />
              </SimpleShowLayout>
            )}
            {(printerStatus as PrinterDto)?.spooling !== undefined && (
              <SimpleShowLayout
                resource="modules"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={printerStatus}
              >
                <BooleanField source="spooling" />
              </SimpleShowLayout>
            )}
            {(printerStatus as PrinterDto)?.ticketPresent !== undefined && (
              <SimpleShowLayout
                resource="modules"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={printerStatus}
              >
                <BooleanField source="ticketPresent" />
              </SimpleShowLayout>
            )}
            {(printerStatus as PrinterDto)?.virtuallPaperEnd !== undefined && (
              <SimpleShowLayout
                resource="modules"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={printerStatus}
              >
                <BooleanField source="virtuallPaperEnd" />
              </SimpleShowLayout>
            )}
          </Grid>
        </AccordionDetails>
      </Accordion>
      <BlankActions />
    </>
  )
}

const DepositorStatus = ({ ...props }) => {
  const { deviceStatus } = props
  const depoStatus = deviceStatus?.[0]
  const classes = useStyles()
  const translate = useTranslate()

  const DoorStatusIcon = () => {
    if (depoStatus?.doorStatus === DepositorDoorStatus.opened)
      return <MeetingRoomIcon className={classes.localIcon} />
    if (depoStatus?.doorStatus === DepositorDoorStatus.closed)
      return <DoorFrontIcon className={classes.localIcon} />
    if (depoStatus?.doorStatus === DepositorDoorStatus.locked) return <Lock />
    return <div />
  }

  const LockerStatusIcon = () => {
    if (depoStatus?.lockerStatus === DepositorLockerStatus.empty)
      return <CheckBoxOutlineBlank />
    if (depoStatus?.lockerStatus === DepositorLockerStatus.full)
      return <CheckBoxIcon />
    if (depoStatus?.lockerStatus === DepositorLockerStatus.reserved)
      return <AccountBox />
    return <div />
  }

  return (
    <>
      <Accordion key="printer">
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6">Depositor</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid
            container
            direction="row"
            justify="space-around"
            alignItems="flex-start"
          >
            {depoStatus?.acsId !== undefined && depoStatus?.acsId !== '' && (
              <SimpleShowLayout
                resource="modules"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={depoStatus}
              >
                <ReferenceField
                  source="acsId"
                  reference={ResourceName.ACCESS_USINGS}
                >
                  <ReferenceField
                    source="ticketId"
                    reference={ResourceName.TICKETS}
                  >
                    <ReferenceField
                      source="bookingId"
                      reference={ResourceName.BOOKINGS}
                      link="show"
                    >
                      <TextField source="id" />
                    </ReferenceField>
                  </ReferenceField>
                </ReferenceField>
              </SimpleShowLayout>
            )}
            {depoStatus?.doorStatus !== undefined &&
              depoStatus?.doorStatus !== '' && (
                <SimpleShowLayout
                  resource="modules"
                  className={classes.simpleShowLayoutWithNoVerticalPadding}
                  record={depoStatus}
                >
                  <FunctionField
                    source="doorStatus"
                    render={(record) => (
                      <div style={{ display: 'flex' }}>
                        <DoorStatusIcon />
                        {translate(
                          `resources.enums.DepositorDoorStatus.${record?.doorStatus}`,
                        )}
                      </div>
                    )}
                  />
                </SimpleShowLayout>
              )}
            {depoStatus?.lockerStatus !== undefined &&
              depoStatus?.lockerStatus !== '' && (
                <SimpleShowLayout
                  resource="modules"
                  className={classes.simpleShowLayoutWithNoVerticalPadding}
                  record={depoStatus}
                >
                  <FunctionField
                    source="lockerStatus"
                    render={(record) => (
                      <div style={{ display: 'flex' }}>
                        <LockerStatusIcon />
                        {translate(
                          `resources.enums.DepositorLockerStatus.${record?.lockerStatus}`,
                        )}
                      </div>
                    )}
                  />
                </SimpleShowLayout>
              )}
            {depoStatus?.lockerSize !== undefined &&
              depoStatus?.lockerSize !== '' && (
                <SimpleShowLayout
                  resource="modules"
                  className={classes.simpleShowLayoutWithNoVerticalPadding}
                  record={depoStatus}
                >
                  <TextField source="lockerSize" />
                </SimpleShowLayout>
              )}
          </Grid>
        </AccordionDetails>
      </Accordion>
      <BlankActions />
    </>
  )
}

const IksorisParkingTicketCashMachineStatus = ({ ...props }) => {
  const { deviceStatus } = props
  const {
    automatApiStatus,
    ticketMachineStatus,
  }: {
    automatApiStatus: AutomatAPIStatusDto
    ticketMachineStatus: IksorisParkingTicketMachineStatusDto
  } = deviceStatus
  const classes = useStyles()
  const translate = useTranslate()

  return (
    <>
      <Accordion key="ticket-machine">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          className={
            CheckIksorisParkingTicketCashMachineError(ticketMachineStatus)
              ? classes.terminatedModuleHeader
              : classes.defaultModuleHeader
          }
        >
          <Typography variant="h6">Iksoris Cash Machine</Typography>
        </AccordionSummary>
        <AccordionDetails
          className={
            CheckIksorisParkingTicketCashMachineError(ticketMachineStatus)
              ? classes.terminatedModuleDetails
              : classes.defaultModuleDetails
          }
        >
          <Grid
            container
            direction="row"
            justify="space-around"
            alignItems="flex-start"
          >
            {ticketMachineStatus?.lastCorrectConfigurationDate && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <DateField
                  source="lastCorrectConfigurationDate"
                  options={{
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                  }}
                />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.controlPanel !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="controlPanel" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.adminPermission !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="adminPermission" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.isTerminalOk !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="isTerminalOk" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.isCashOk !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="isCashOk" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.isKioskPrinterOk !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="isKioskPrinterOk" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.isKioskPrinterInitialized !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="isKioskPrinterInitialized" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.kioskPrinterSupportStatus !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="kioskPrinterSupportStatus" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.isKioskPrinterStatusOk !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="isKioskPrinterStatusOk" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.kioskPrinterPaperLow !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="kioskPrinterPaperLow" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.kioskPrinterPaperEnd !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="kioskPrinterPaperEnd" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.isTicketPrinterOk !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="isTicketPrinterOk" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.isTicketPrinterInitialized !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="isTicketPrinterInitialized" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.ticketPrinterSupportStatus !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="ticketPrinterSupportStatus" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.isTicketPrinterStatusOk !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="isTicketPrinterStatusOk" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.ticketPrinterPaperLow !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="ticketPrinterPaperLow" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.ticketPrinterPaperEnd !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="ticketPrinterPaperEnd" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.isFiscalPrinterOk !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="isFiscalPrinterOk" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.isFiscalPrinterInitialized !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="isFiscalPrinterInitialized" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.fiscalPrinterSupportStatus !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="fiscalPrinterSupportStatus" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.isFiscalPrinterStatusOk !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="isFiscalPrinterStatusOk" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.fiscalPrinterPaperLow !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="fiscalPrinterPaperLow" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.fiscalPrinterPaperEnd !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="fiscalPrinterPaperEnd" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.isRFIDOk !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="isRFIDOk" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.isBarcodeReaderOk !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="isBarcodeReaderOk" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.isBarcodeReaderOn !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="isBarcodeReaderOn" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.apiAuthorizationOk !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="apiAuthorizationOk" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.serverStarted !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="serverStarted" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.ekranyReady !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="ekranyReady" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.locked !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="locked" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.displayState !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <TextField source="displayState" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.deviceInfo?.version !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <TextField source="deviceInfo.version" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.transactionError !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="transactionError" />
              </SimpleShowLayout>
            )}
          </Grid>
        </AccordionDetails>
      </Accordion>
      <BlankActions />
      <Accordion key="automat-api">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          className={
            CheckAutomatAPIError(automatApiStatus)
              ? classes.terminatedModuleHeader
              : classes.defaultModuleHeader
          }
        >
          <Typography variant="h6">Automat API</Typography>
        </AccordionSummary>
        <AccordionDetails
          className={
            CheckAutomatAPIError(automatApiStatus)
              ? classes.terminatedModuleDetails
              : classes.defaultModuleDetails
          }
        >
          <Grid
            container
            direction="row"
            justify="space-around"
            alignItems="flex-start"
          >
            {automatApiStatus?.currenzaMdbChanger?.name && (
              <SimpleShowLayout
                resource="automat-api-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={automatApiStatus as any}
              >
                <TextField source="currenzaMdbChanger.name" />
              </SimpleShowLayout>
            )}
            {automatApiStatus?.currenzaMdbChanger?.enabled !== undefined && (
              <SimpleShowLayout
                resource="automat-api-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={automatApiStatus as any}
              >
                <BooleanField source="currenzaMdbChanger.enabled" />
              </SimpleShowLayout>
            )}
            {automatApiStatus?.currenzaMdbChanger?.statuses && (
              <SimpleShowLayout
                resource="automat-api-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={automatApiStatus as any}
              >
                <FunctionField
                  source="currenzaMdbChanger.statuses"
                  render={() =>
                    automatApiStatus.currenzaMdbChanger.statuses.map((s) => (
                      <div style={{ display: 'flex' }} key={s}>
                        {translate(
                          `resources.enums.TicketMachines.MDBPoolStatuses.${s}`,
                        )}
                      </div>
                    ))
                  }
                />
              </SimpleShowLayout>
            )}
            {automatApiStatus?.currenzaMdbChanger?.diagnosticStatuses && (
              <SimpleShowLayout
                resource="automat-api-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={automatApiStatus as any}
              >
                <FunctionField
                  source="currenzaMdbChanger.diagnosticStatuses"
                  render={() =>
                    automatApiStatus.currenzaMdbChanger.diagnosticStatuses.map(
                      (s) => (
                        <div style={{ display: 'flex' }} key={s}>
                          {translate(
                            `resources.enums.TicketMachines.MDBDiagnosticStatuses.${s}`,
                          )}
                        </div>
                      ),
                    )
                  }
                />
              </SimpleShowLayout>
            )}

            {automatApiStatus?.nV200NotePayout?.name && (
              <SimpleShowLayout
                resource="automat-api-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={automatApiStatus as any}
              >
                <TextField source="nV200NotePayout.name" />
              </SimpleShowLayout>
            )}
            {automatApiStatus?.nV200NotePayout?.enabled !== undefined && (
              <SimpleShowLayout
                resource="automat-api-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={automatApiStatus as any}
              >
                <BooleanField source="nV200NotePayout.enabled" />
              </SimpleShowLayout>
            )}
            {automatApiStatus?.nV200NotePayout?.statuses && (
              <SimpleShowLayout
                resource="automat-api-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={automatApiStatus as any}
              >
                <FunctionField
                  source="nV200NotePayout.statuses"
                  render={() =>
                    automatApiStatus.nV200NotePayout.statuses.map((s) => (
                      <div style={{ display: 'flex' }} key={s}>
                        {translate(
                          `resources.enums.TicketMachines.NV200Statuses._${s}`,
                        )}
                      </div>
                    ))
                  }
                />
              </SimpleShowLayout>
            )}
          </Grid>
        </AccordionDetails>
      </Accordion>
      <BlankActions />
    </>
  )
}

const IksorisParkingTicketCashlessMachineStatus = ({ ...props }) => {
  const { deviceStatus } = props
  const {
    ticketMachineStatus,
  }: {
    ticketMachineStatus: IksorisParkingTicketMachineStatusDto
  } = deviceStatus
  const classes = useStyles()

  return (
    <>
      <Accordion key="ticket-machine">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          className={
            CheckIksorisParkingTicketCashlessMachineError(ticketMachineStatus)
              ? classes.terminatedModuleHeader
              : classes.defaultModuleHeader
          }
        >
          <Typography variant="h6">Iksoris Cashless Machine</Typography>
        </AccordionSummary>
        <AccordionDetails
          className={
            CheckIksorisParkingTicketCashlessMachineError(ticketMachineStatus)
              ? classes.terminatedModuleDetails
              : classes.defaultModuleDetails
          }
        >
          <Grid
            container
            direction="row"
            justify="space-around"
            alignItems="flex-start"
          >
            {ticketMachineStatus?.lastCorrectConfigurationDate && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <DateField
                  source="lastCorrectConfigurationDate"
                  options={{
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                  }}
                />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.controlPanel !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="controlPanel" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.adminPermission !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="adminPermission" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.isTerminalOk !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="isTerminalOk" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.isKioskPrinterOk !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="isKioskPrinterOk" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.isKioskPrinterInitialized !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="isKioskPrinterInitialized" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.kioskPrinterSupportStatus !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="kioskPrinterSupportStatus" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.isKioskPrinterStatusOk !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="isKioskPrinterStatusOk" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.kioskPrinterPaperLow !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="kioskPrinterPaperLow" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.kioskPrinterPaperEnd !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="kioskPrinterPaperEnd" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.isTicketPrinterOk !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="isTicketPrinterOk" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.isTicketPrinterInitialized !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="isTicketPrinterInitialized" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.ticketPrinterSupportStatus !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="ticketPrinterSupportStatus" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.isTicketPrinterStatusOk !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="isTicketPrinterStatusOk" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.ticketPrinterPaperLow !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="ticketPrinterPaperLow" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.ticketPrinterPaperEnd !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="ticketPrinterPaperEnd" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.isFiscalPrinterOk !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="isFiscalPrinterOk" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.isFiscalPrinterInitialized !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="isFiscalPrinterInitialized" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.fiscalPrinterSupportStatus !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="fiscalPrinterSupportStatus" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.isFiscalPrinterStatusOk !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="isFiscalPrinterStatusOk" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.fiscalPrinterPaperLow !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="fiscalPrinterPaperLow" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.fiscalPrinterPaperEnd !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="fiscalPrinterPaperEnd" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.isRFIDOk !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="isRFIDOk" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.isBarcodeReaderOk !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="isBarcodeReaderOk" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.isBarcodeReaderOn !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="isBarcodeReaderOn" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.apiAuthorizationOk !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="apiAuthorizationOk" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.serverStarted !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="serverStarted" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.ekranyReady !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="ekranyReady" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.locked !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="locked" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.displayState !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <TextField source="displayState" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.deviceInfo?.version !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <TextField source="deviceInfo.version" />
              </SimpleShowLayout>
            )}
            {ticketMachineStatus?.transactionError !== undefined && (
              <SimpleShowLayout
                resource="ticket-machine-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={ticketMachineStatus as any}
              >
                <BooleanField source="transactionError" />
              </SimpleShowLayout>
            )}
          </Grid>
        </AccordionDetails>
      </Accordion>
      <BlankActions />
    </>
  )
}

const SelfPOSAccessTicketCashlessMachineStatus = ({ ...props }) => {
  const { deviceStatus } = props
  const {
    selfPosStatus,
  }: {
    selfPosStatus: SelfPOSAccessTicketMachineStatusDto
  } = deviceStatus
  const classes = useStyles()
  const translate = useTranslate()

  const printerConfigs = [
    {
      key: 'ticketPrinter',
      record: selfPosStatus.ticketPrinter,
      source: 'ticketPrinterStatus',
    },
    {
      key: 'paymentConfirmationPrinter',
      record: selfPosStatus.paymentConfirmationPrinter,
      source: 'paymentConfirmationPrinterStatus',
    },
    {
      key: 'receiptPrinter',
      record: selfPosStatus.receiptPrinter,
      source: 'receiptPrinterStatus',
    },
  ]

  return (
    <>
      <Accordion key="self-pos">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          className={
            CheckSelfPOSAPIError(selfPosStatus)
              ? classes.terminatedModuleHeader
              : classes.defaultModuleHeader
          }
        >
          <Typography variant="h6">SelfPOS</Typography>
        </AccordionSummary>
        <AccordionDetails
          className={
            CheckSelfPOSAPIError(selfPosStatus)
              ? classes.terminatedModuleDetails
              : classes.defaultModuleDetails
          }
        >
          <Grid
            container
            direction="row"
            justify="space-around"
            alignItems="flex-start"
          >
            {/* Loop over all 3 SelfPOS printers */}
            {printerConfigs.map(({ key, record, source }) => (
              <SimpleShowLayout
                key={key}
                resource="selfpos-api-status"
                className={classes.simpleShowLayoutWithNoVerticalPadding}
                record={record as any}
              >
                <FunctionField
                  source={source}
                  render={(rec: any) => (
                    <div style={{ display: 'flex' }} key={rec.status}>
                      {rec.status
                        ? translate(
                            `resources.enums.TicketMachines.PrinterStatuses.${rec.status}`,
                          )
                        : '-'}
                    </div>
                  )}
                />
              </SimpleShowLayout>
            ))}
          </Grid>
        </AccordionDetails>
      </Accordion>
      {/* <BlankActions /> */}
    </>
  )
}

const CameraServerStatus = ({ ...props }) => {
  const classes = useStyles()
  const translate = useTranslate()
  const { deviceStatus, cameraType } = props
  const cameraServerStatus = deviceStatus as CameraServerStatusDto

  return (
    <>
      {cameraServerStatus && cameraType === CameraTypes.HIKVISION_RTSP && (
        <Accordion key="camera">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            className={
              CheckCameraServerError(deviceStatus, CameraTypes.HIKVISION_RTSP)
                ? classes.terminatedModuleHeader
                : classes.defaultModuleHeader
            }
          >
            <Typography variant="h6">{cameraType}</Typography>
          </AccordionSummary>
          <AccordionDetails
            className={
              CheckCameraServerError(deviceStatus, CameraTypes.HIKVISION_RTSP)
                ? classes.terminatedModuleDetails
                : classes.defaultModuleDetails
            }
          >
            <Grid
              container
              direction="row"
              justify="space-around"
              alignItems="flex-start"
            >
              {cameraServerStatus?.hikvisionServerStatus.deviceStatus !==
                undefined && (
                <SimpleShowLayout
                  resource="camera-server-status"
                  className={classes.simpleShowLayoutWithNoVerticalPadding}
                  record={cameraServerStatus as any}
                >
                  <FunctionField
                    source="deviceStatus"
                    render={(record: any) => (
                      <div
                        style={{ display: 'flex' }}
                        key={record.hikvisionServerStatus.deviceStatus}
                      >
                        {translate(
                          `resources.enums.CameraServerDeviceStatus.Hikvision.${record.hikvisionServerStatus.deviceStatus}`,
                        )}
                      </div>
                    )}
                  />
                </SimpleShowLayout>
              )}
              {cameraServerStatus?.hikvisionServerStatus.hddStatuses !==
                undefined && (
                <SimpleShowLayout
                  resource="camera-server-status"
                  className={classes.simpleShowLayoutWithNoVerticalPadding}
                  record={cameraServerStatus as any}
                >
                  <FunctionField
                    source="hddStatuses"
                    render={(record: any) => (
                      <div>
                        {record.hikvisionServerStatus.hddStatuses.map(
                          (hdd: any) => (
                            <div
                              key={hdd.hddNumber}
                              style={{ display: 'flex', marginBottom: '4px' }}
                            >
                              {translate('resources.modules.fields.hddNumber')}:{' '}
                              {hdd.hddNumber} -{' '}
                              {translate(
                                `resources.enums.CameraServerHddStatus.Hikvision.${hdd.status}`,
                              )}
                            </div>
                          ),
                        )}
                      </div>
                    )}
                  />
                </SimpleShowLayout>
              )}
            </Grid>
          </AccordionDetails>
        </Accordion>
      )}
    </>
  )
}

const CameraStatus = ({ ...props }) => {
  const classes = useStyles()
  const { deviceStatus, cameraType } = props
  const translate = useTranslate()

  // Przygotowane na inne typy kamery
  let cameraStatus
  if (cameraType === CameraTypes.HIKVISION_RTSP) {
    cameraStatus = deviceStatus.hikvisionCameraStatus as HikvisionStatusDto
  }

  return (
    <>
      {cameraStatus && cameraType === CameraTypes.HIKVISION_RTSP && (
        <>
          <Accordion key="camera">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              className={
                CheckCameraError(deviceStatus, cameraType)
                  ? classes.terminatedModuleHeader
                  : classes.defaultModuleHeader
              }
            >
              <Typography variant="h6">{cameraType}</Typography>
            </AccordionSummary>
            <AccordionDetails
              className={
                CheckCameraError(deviceStatus, cameraType)
                  ? classes.terminatedModuleDetails
                  : classes.defaultModuleDetails
              }
            >
              <Grid
                container
                direction="row"
                justify="space-around"
                alignItems="flex-start"
              >
                {cameraStatus?.isOnline !== undefined && (
                  <SimpleShowLayout
                    resource="camera-status"
                    className={classes.simpleShowLayoutWithNoVerticalPadding}
                    record={cameraStatus as any}
                  >
                    <BooleanField source="isOnline" />
                  </SimpleShowLayout>
                )}
                {cameraStatus?.isRecording !== undefined && (
                  <SimpleShowLayout
                    resource="camera-status"
                    className={classes.simpleShowLayoutWithNoVerticalPadding}
                    record={cameraStatus as any}
                  >
                    <BooleanField source="isRecording" />
                  </SimpleShowLayout>
                )}
                {cameraStatus?.channelNumber !== undefined && (
                  <SimpleShowLayout
                    resource="camera-status"
                    className={classes.simpleShowLayoutWithNoVerticalPadding}
                    record={cameraStatus as any}
                  >
                    <TextField source="channelNumber" />
                  </SimpleShowLayout>
                )}
                {cameraStatus?.bitRate !== undefined && (
                  <SimpleShowLayout
                    resource="camera-status"
                    className={classes.simpleShowLayoutWithNoVerticalPadding}
                    record={cameraStatus as any}
                  >
                    <TextField source="bitRate" />
                  </SimpleShowLayout>
                )}
                {cameraStatus?.hardwareStatus !== undefined && (
                  <SimpleShowLayout
                    resource="camera-status"
                    className={classes.simpleShowLayoutWithNoVerticalPadding}
                    record={cameraStatus as any}
                  >
                    <FunctionField
                      source="hardwareStatus"
                      render={(record: any) => (
                        <div
                          style={{ display: 'flex' }}
                          key={record.hardwareStatus}
                        >
                          {translate(
                            `resources.enums.CameraHardwareStatus.Hikvision.${record.hardwareStatus}`,
                          )}
                        </div>
                      )}
                    />
                  </SimpleShowLayout>
                )}
                {cameraStatus?.recordingStatus !== undefined && (
                  <SimpleShowLayout
                    resource="camera-status"
                    className={classes.simpleShowLayoutWithNoVerticalPadding}
                    record={cameraStatus as any}
                  >
                    <FunctionField
                      source="recordingStatus"
                      render={(record: any) => (
                        <div
                          style={{ display: 'flex' }}
                          key={record.recordingStatus}
                        >
                          {translate(
                            `resources.enums.CameraRecordingStatus.Hikvision.${record.recordingStatus}`,
                          )}
                        </div>
                      )}
                    />
                  </SimpleShowLayout>
                )}
                {cameraStatus?.recordingStatus !== undefined && (
                  <SimpleShowLayout
                    resource="camera-status"
                    className={classes.simpleShowLayoutWithNoVerticalPadding}
                    record={cameraStatus as any}
                  >
                    <TextField source="name" />
                  </SimpleShowLayout>
                )}
              </Grid>
            </AccordionDetails>
          </Accordion>
          <BlankActions />
        </>
      )}
    </>
  )
}

const getOtherCustomNonModuleProperties = (rawJsonStatus: string) => {
  let otherProperties
  try {
    const jsonStatus = camelcaseKeys(JSON.parse(rawJsonStatus), { deep: true })
    if (jsonStatus !== null || jsonStatus !== undefined) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { modules, ...others } = jsonStatus
      otherProperties = others
    }
  } catch {
    otherProperties = undefined
  }
  return otherProperties
}

const DeviceStatusesTab = (props: StatusTabProps) => {
  const {
    jsonStatus: rawJsonStatus,
    statusIndex,
    reversedDirection,
    deviceType,
    referenceDateTime,
    cameraType,
  } = props
  const mappedModules = getModulesFromJsonStatus(rawJsonStatus)
  const otherProperties = getOtherCustomNonModuleProperties(rawJsonStatus)

  return (
    <div>
      {deviceType === DeviceTypes.TERMINALS &&
        otherProperties?.printerStatus && (
          <TerminalStatus deviceStatus={otherProperties} />
        )}
      {deviceType === DeviceTypes.DEPOSITOR && (
        <DepositorStatus deviceStatus={otherProperties} />
      )}
      {deviceType === DeviceTypes.IKSORIS_PARKING_TICKET_CASH_MACHINE && (
        <IksorisParkingTicketCashMachineStatus deviceStatus={otherProperties} />
      )}
      {deviceType === DeviceTypes.IKSORIS_PARKING_TICKET_CASHLESS_MACHINE && (
        <IksorisParkingTicketCashlessMachineStatus
          deviceStatus={otherProperties}
        />
      )}
      {deviceType === DeviceTypes.SELFPOS_ACCESS_TICKET_CASHLESS_MACHINE && (
        <SelfPOSAccessTicketCashlessMachineStatus
          deviceStatus={otherProperties}
        />
      )}
      {deviceType === DeviceTypes.CAMERA && (
        <CameraStatus deviceStatus={otherProperties} cameraType={cameraType} />
      )}
      {deviceType === DeviceTypes.CAMERA_SERVER && (
        <CameraServerStatus
          deviceStatus={otherProperties}
          cameraType={cameraType}
        />
      )}
      <MultiModuleStatus
        moduleInfo={mappedModules
          .filter((m) => m != null)
          .map((m) => m as ModuleBaseDto)}
        statusIndex={statusIndex}
        reversedDirection={reversedDirection}
        referenceDateTime={referenceDateTime}
      />
    </div>
  )
}

const DeviceStatusesPreview = (props: StatusTabProps) => {
  const classes = useStyles()
  const { jsonStatus: rawJsonStatus, deviceType, referenceDateTime } = props
  const mappedModules = getModulesFromJsonStatus(rawJsonStatus)
    .filter((m) => m != null)
    .map((m) => m as ModuleBaseDto)
  const otherProperties = getOtherCustomNonModuleProperties(rawJsonStatus)

  return (
    <Grid
      container
      direction="row"
      justify="flex-start"
      alignItems="flex-start"
    >
      {deviceType === DeviceTypes.TERMINALS && otherProperties?.printerStatus && (
        <Grid item key="Printer" style={{ margin: 3 }}>
          <Box
            p={1}
            className={
              CheckPrinterError(otherProperties?.printerStatus)
                ? classes.previewedDeviceError
                : classes.previewedDeviceOk
            }
          >
            Printer
          </Box>
        </Grid>
      )}
      {mappedModules.map((module, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Grid item key={index} style={{ margin: 3 }}>
          <Box
            p={1}
            className={
              CheckModulesError([module], referenceDateTime)
                ? classes.previewedDeviceError
                : classes.previewedDeviceOk
            }
          >
            <TextField source="module.alias" record={module} />
          </Box>
        </Grid>
      ))}
    </Grid>
  )
}

const CheckIfAnyModuleHasError = (
  rawJsonStatus: string,
  deviceType: DeviceTypes,
  referenceDateTime: DateTime,
) => {
  const mappedModules = getModulesFromJsonStatus(rawJsonStatus)
    .filter((m) => m != null)
    .map((m) => m as ModuleBaseDto)
  const otherProperties = getOtherCustomNonModuleProperties(rawJsonStatus)

  let error = CheckModulesError(mappedModules, referenceDateTime)
  if (!error) {
    // Check for error in custom device properties
    switch (deviceType) {
      case DeviceTypes.TERMINALS:
        error = CheckPrinterError(otherProperties?.printerStatus)
        break
      case DeviceTypes.DOORS:
        error = CheckDoorError(otherProperties)
        break
      case DeviceTypes.IKSORIS_PARKING_TICKET_CASH_MACHINE:
        error =
          CheckIksorisParkingTicketCashMachineError(
            otherProperties?.ticketMachineStatus,
          ) || CheckAutomatAPIError(otherProperties?.automatApiStatus)
        break
      case DeviceTypes.IKSORIS_PARKING_TICKET_CASHLESS_MACHINE:
        error = CheckIksorisParkingTicketCashlessMachineError(
          otherProperties?.ticketMachineStatus,
        )
        break
      case DeviceTypes.SELFPOS_ACCESS_TICKET_CASHLESS_MACHINE:
        error = CheckSelfPOSAPIError(otherProperties?.selfPosStatus)
        break
      default:
        break
    }
  }
  return error
}

interface ModuleBaseStatusProps {
  readonly moduleInfo: ModuleBaseDto
  readonly disableAliasHeader?: boolean
  readonly children?: ReactNode[]
  // readonly statusIndex?: number
}

interface ModuleStatusProps {
  readonly moduleInfo: ModuleBaseDto
  readonly disableAliasHeader?: boolean
  readonly statusIndex?: number
  readonly reversedDirection?: boolean
}

interface MultiModuleStatusProps {
  readonly moduleInfo: ModuleBaseDto[]
  readonly statusIndex?: number
  readonly reversedDirection?: boolean
  readonly referenceDateTime: DateTime
}

interface StatusTabProps {
  readonly jsonStatus: string
  // eslint-disable-next-line react/no-unused-prop-types
  readonly statusIndex?: number
  // eslint-disable-next-line react/no-unused-prop-types
  readonly reversedDirection?: boolean
  // eslint-disable-next-line react/no-unused-prop-types
  readonly cameraType?: CameraTypes | string
  readonly deviceType: DeviceTypes
  readonly referenceDateTime: DateTime
}

export {
  CheckCameraError,
  CheckCameraServerError,
  CheckIfAnyModuleHasError,
  CheckLastRefreshError,
  DeviceStatusesPreview,
  DeviceStatusesTab,
  ModuleStatus,
  MultiModuleStatus,
}
